import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { FontSizeProvider } from './contexts/FontSizeContext';
import ErrorBoundary from './components/ErrorBoundary';

// Remoção imediata do loader assim que o bundle JS é executado no mobile
try {
  const loader = document.getElementById('loading-screen');
  if (loader && loader.parentNode) {
    loader.style.opacity = '0';
    loader.style.pointerEvents = 'none';
    setTimeout(() => {
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }
    }, 300);
  }
} catch (e) {
  console.warn('Erro ao remover loading-screen:', e);
}

// Auto-refresh logic to handle new site deployments gracefully
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('Failed to fetch dynamically imported module')) {
    window.location.reload();
  }
});

window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <FontSizeProvider>
        <App />
      </FontSizeProvider>
    </ErrorBoundary>
  </StrictMode>,
);

